type Props = {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  ariaLabel: string;
  className?: string;
  disabled?: boolean;
  /** "large": Hauptsuche einer Seite (Artikel), höher und mit größerer Lupe. */
  size?: "default" | "large";
};

export default function SearchInput({
  value,
  onChange,
  placeholder,
  ariaLabel,
  className,
  disabled,
  size = "default",
}: Props) {
  const large = size === "large";
  return (
    <div
      className={[
        large ? "relative w-full min-w-0" : "relative min-w-0 max-w-sm flex-1 sm:min-w-[18rem]",
        className ?? "",
      ]
        .join(" ")
        .trim()}
    >
      <svg
        aria-hidden="true"
        className={`pointer-events-none absolute top-1/2 -translate-y-1/2 ${large ? "left-4 h-[22px] w-[22px] text-slate-500" : "left-3 h-4 w-4 text-slate-400"}`}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="11" cy="11" r="7" />
        <path d="m21 21-4.3-4.3" />
      </svg>
      <input
        type="search"
        disabled={disabled}
        aria-label={ariaLabel}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        className={`w-full border bg-white text-slate-900 placeholder:text-slate-400 focus:border-emerald-300 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 ${
          large ? "h-[52px] rounded-lg border-slate-300 pl-12 pr-4 text-base shadow-sm" : "h-9 rounded-md border-slate-200 pl-9 pr-3 text-sm"
        }`}
      />
    </div>
  );
}
